function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import PageComponent from '../base/PageComponent';
var MobileMenu = /*#__PURE__*/function (_PageComponent) {
  _inherits(MobileMenu, _PageComponent);
  var _super = _createSuper(MobileMenu);
  function MobileMenu() {
    _classCallCheck(this, MobileMenu);
    return _super.apply(this, arguments);
  }
  _createClass(MobileMenu, [{
    key: "init",
    value: function init() {
      var _this = this;
      // The container
      this.section = document.querySelector('.js-mobile-menu');
      // The links will be groups in here
      this.links = {};
      // Find top level links
      this.parents = this.section.querySelectorAll('[data-parent-id]');
      // A throttle
      this.throttle = null;
      // The toggles
      this.buttons = {
        open: document.querySelector('.js-mobile-menu--open') || false,
        close: document.querySelector('.js-mobile-menu--close') || false
      };
      if (this.buttons.open) {
        this.buttons.open.addEventListener('click', function (e) {
          e.preventDefault();
          _this.open();
        });
      }
      if (this.buttons.close) {
        this.buttons.close.addEventListener('click', function (e) {
          e.preventDefault();
          _this.close();
        });
      }

      // Loop through the parent links and assign them to their ID in the links object
      var _loop = function _loop() {
        var parent = _this.parents[index];
        var ID = parent.getAttribute('data-parent-id');
        var children = _this.section.querySelector("[data-children-id=\"".concat(ID, "\"]")) || false;
        if (children) {
          var back = children.querySelector('.js-mobile-menu--back');
          _this.links[ID] = {
            parent: parent,
            children: children
          };
          parent.addEventListener('click', function (e) {
            e.preventDefault();
            _this.next(ID);
          });
          back.addEventListener('click', function (e) {
            e.preventDefault();
            _this.back(ID);
          });
        }
      };
      for (var index = 0; index < this.parents.length; index++) {
        _loop();
      }
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;
      clearTimeout(this.throttle);
      this.throttle = setTimeout(function () {
        _this2.section.style.display = 'block';
        setTimeout(function () {
          _this2.section.classList.add('js-mobile-menu--open');
        }, 50);
      }, 100);
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;
      clearTimeout(this.throttle);
      this.throttle = setTimeout(function () {
        _this3.section.classList.remove('js-mobile-menu--open');
        setTimeout(function () {
          _this3.section.style.display = 'none';
        }, 300);
      }, 100);
    }
  }, {
    key: "next",
    value: function next(ID) {
      var _this4 = this;
      if (this.links[ID]) {
        clearTimeout(this.throttle);
        this.throttle = setTimeout(function () {
          _this4.links[ID].children.style.display = 'block';
          setTimeout(function () {
            _this4.links[ID].children.classList.add('js-mobile-menu--open');
          }, 50);
        }, 100);
      }
    }
  }, {
    key: "back",
    value: function back(ID) {
      var _this5 = this;
      if (this.links[ID]) {
        clearTimeout(this.throttle);
        this.throttle = setTimeout(function () {
          _this5.links[ID].children.classList.remove('js-mobile-menu--open');
          setTimeout(function () {
            _this5.links[ID].children.style.display = 'none';
          }, 300);
        }, 100);
      }
    }
  }]);
  return MobileMenu;
}(PageComponent);
export { MobileMenu as default };